module.exports = __webpack_public_path__ + "img/sheardt.e5caa0f0.jpg";